import { render, staticRenderFns } from "./GLoader.vue?vue&type=template&id=7c9d9844&"
import script from "./GLoader.vue?vue&type=script&lang=js&"
export * from "./GLoader.vue?vue&type=script&lang=js&"
import style0 from "./GLoader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c9d9844')) {
      api.createRecord('7c9d9844', component.options)
    } else {
      api.reload('7c9d9844', component.options)
    }
    module.hot.accept("./GLoader.vue?vue&type=template&id=7c9d9844&", function () {
      api.rerender('7c9d9844', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/GLoader.vue"
export default component.exports